import React, { createContext, useEffect, useMemo, useState } from 'react';
import { startAccountSync } from './mainpage/account_sync/account_sync';

const AccountContext = createContext();

export const AccountProvider = ({ wallet, jwt, children }) => {
    const [accountData, setAccountData] = useState(null);
    const [lastSync, setLastSync] = useState(0);
    const [loading, setLoading] = useState(!!wallet && !!jwt);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!wallet || !jwt) {
            setAccountData(null);
            setLoading(false);
            setError('');
            return;
        }

        setLoading(true);
        setError('');

        const stop = startAccountSync({
            wallet_address: wallet,
            jwt,
            onUpdate: (data) => {
                setAccountData(data);
                setLastSync(Date.now());
                setLoading(false);
            },
            onError: (err) => {
                setError(err?.message || 'Failed to sync account');
                setLoading(false);
            },
            intervalMs: 10_000,
        });

        return stop;
    }, [wallet, jwt]);

    const value = useMemo(
        () => ({ accountData, lastSync, loading, error }),
        [accountData, lastSync, loading, error]
    );

    return (
        <AccountContext.Provider value={value}>
            {children}
        </AccountContext.Provider>
    );
};

export default AccountContext;
